import { forEach } from 'lodash'

const addGTMClass = ids => {
  forEach(ids, id => {
    const element = document.getElementById(id)
    if (element) {
      element.classList.add(`zt-gtm-${id}`)
    }
  })
}

export default addGTMClass
